import { Pipe, PipeTransform } from '@angular/core';
import { FundOrderStatusesEnum } from '@spa/api';
import { Helper } from '../classes';
import { LanguageService } from '../language.service';

@Pipe({
  name: 'orderStatus',
  pure: true
})
export class OrderStatusPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {
  }

  transform(value: FundOrderStatusesEnum): string {
    const language = this.languageService.getCurrentLanguage();

    return Helper.textsHelper().getOrderStatusName(value, language);
  }
}
